import { BOOKING_COMMENTS, BACKPAGE_TO_REDIRECT, PNR_HISTORY, MANIFEST_DETAILS, SET_SIDEMENU_FLAG } from './SideMenuType';

export const bookingCommentsCredentials=(props)=>
{
    // debugger;  
    return{
        type:BOOKING_COMMENTS,
        CommentsForCurrentBooking:props.CommentsForCurrentBooking,
    }
}

export const redirectToPageCredentials=(props)=>
{
    // debugger;  
    return{
        type:BACKPAGE_TO_REDIRECT,
        redirectionPage:props.redirectionPage,
    }
}

export const bookingPnrHistory=(props)=>
{ 
    return{
        type:PNR_HISTORY,
        pnrHistory:props.pnrHistory,
    }
}

export const flightManifestDetails=(props)=>
{ 
    return{
        type:MANIFEST_DETAILS,
        manifestDetails:props.manifestDetails,
    }
}

export const setSidemenuFlag=(props) => {
    debugger
    return {
        type: SET_SIDEMENU_FLAG,
        sideMenuFlag: props.sideMenuFlag
    }
}
